"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRnaSeqBaseline = exports.isMultiExperiment = exports.isDifferential = exports.isBaseline = exports.experimentPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var experimentPropTypes = _propTypes["default"].shape({
  accession: _propTypes["default"].string.isRequired,
  // Is it worth to enumerate the experiment types?
  type: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string.isRequired,
  species: _propTypes["default"].string.isRequired
});

exports.experimentPropTypes = experimentPropTypes;

var isMultiExperiment = function isMultiExperiment(experiment) {
  return !Boolean(experiment);
}; // From ExperimentType.java:
// RNASEQ_MRNA_BASELINE("rnaseq_mrna_baseline")
// RNASEQ_MRNA_DIFFERENTIAL("rnaseq_mrna_differential")
// MICROARRAY_ANY("microarray parent type")
// MICROARRAY_1COLOUR_MRNA_DIFFERENTIAL(MICROARRAY_ANY, "microarray_1colour_mrna_differential")
// MICROARRAY_2COLOUR_MRNA_DIFFERENTIAL(MICROARRAY_ANY, "microarray_2colour_mrna_differential")
// MICROARRAY_1COLOUR_MICRORNA_DIFFERENTIAL(MICROARRAY_ANY, "microarray_1colour_microrna_differential")
// PROTEOMICS_BASELINE("proteomics_baseline")
// SINGLE_CELL_RNASEQ_MRNA_BASELINE("scrnaseq_mrna_baseline")


exports.isMultiExperiment = isMultiExperiment;

var isDifferential = function isDifferential(experiment) {
  return !isMultiExperiment(experiment) && experiment.type.toUpperCase().endsWith("DIFFERENTIAL");
};

exports.isDifferential = isDifferential;

var isBaseline = function isBaseline(experiment) {
  return !isMultiExperiment(experiment) && experiment.type.toUpperCase().includes("BASELINE");
};

exports.isBaseline = isBaseline;

var isRnaSeqBaseline = function isRnaSeqBaseline(experiment) {
  return !isMultiExperiment(experiment) && experiment.type.toUpperCase() === "RNASEQ_MRNA_BASELINE";
};

exports.isRnaSeqBaseline = isRnaSeqBaseline;